var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9762 9.96125C15.9806 10.0494 15.9825 10.1369 15.9825 10.2262C15.9825 12.9375 13.9187 16.0638 10.145 16.0638C8.98563 16.0638 7.90812 15.7244 7 15.1419C7.16125 15.16 7.32375 15.17 7.48938 15.17C8.45125 15.17 9.335 14.8431 10.0369 14.2925C9.14 14.275 8.38188 13.6819 8.12125 12.8675C8.24625 12.8906 8.37437 12.9044 8.50688 12.9044C8.69438 12.9044 8.87563 12.8787 9.04688 12.8325C8.10938 12.6431 7.40125 11.8144 7.40125 10.8206V10.795C7.67875 10.9488 7.995 11.0406 8.33125 11.0513C7.78062 10.6838 7.41875 10.055 7.41875 9.34375C7.41875 8.9675 7.52 8.615 7.69625 8.31187C8.7075 9.55375 10.22 10.37 11.925 10.4556C11.89 10.3056 11.8719 10.1494 11.8719 9.98812C11.8719 8.855 12.79 7.9375 13.9237 7.9375C14.5131 7.9375 15.0469 8.18625 15.4206 8.58437C15.8875 8.4925 16.3275 8.32188 16.7238 8.08625C16.57 8.56625 16.2456 8.9675 15.8219 9.22125C16.2369 9.1725 16.6325 9.06187 17 8.89937C16.725 9.31063 16.3775 9.67188 15.9762 9.96125ZM12 2C6.4775 2 2 6.4775 2 12C2 17.5238 6.4775 22 12 22C17.5225 22 22 17.5238 22 12C22 6.4775 17.5225 2 12 2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCircle);
export default __webpack_public_path__ + "static/media/twitter_circle.9be4af00.svg";
export { ForwardRef as ReactComponent };